module.exports = __webpack_public_path__ + "img/DSC_0015.4f732336.jpg";